import React from "react";
import {
  MButton2,
  MCheckbox,
  MInput,
  MLabel,
  MSearchUniversity,
  MSelect,
  ValidatedForm,
} from "components/forms";
import { payloadBuilder } from "libs";

export class DichiarazioneTitoloEstero extends ValidatedForm {
  emptyFields = {
    istitution: "",
    city: "",
    foreignIstitution: "",
    foreignCity: "",
    nation: "",
    denominazione: "",
    aa: "",
    dataConseguimento: "",
    riconoscimentoMIUR: "",
    numProtocollo: "",
    baseVote: 110,
    votoTitolo: "",
    description: "",
    lode: "",
  };

  state = {
    showSearchUniversity: false,
    loading: true,
    ...this.emptyFields,
    defaultValues: {
      ...this.emptyFields,
    },
  };

  PAYLOADS = {
    qualificationTitle: [
      { label: "Seleziona un Titolo", value: "" },
      ...this.props.payloadTitle,
    ],
  };

  constructor(props) {
    super(props);

    // bind event handler to invoke it from the child component
    this.onChange = this.onChange.bind(this);
  }

  FIELDS_GROUP = [
    [
      {
        id: "istitution010",
        field: "foreignIstitution",
        label: "Presso Ateneo Estero",
        component: MInput,
        type: "text",
        className: "col-md-6 mt-4",
      },
      {
        id: "city010",
        field: "foreignCity",
        label: "Città Estera",
        component: MInput,
        type: "text",
        className: "col-md-3 mt-4",
      },
      {
        id: "nation010",
        field: "nation",
        label: "Nazione",
        component: MInput,
        type: "text",
        className: "col-md-3 mt-4",
      },
    ],
    [
      {
        id: "denominazione010",
        field: "denominazione",
        label: "Denominazione Titolo",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "aa010",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MInput,
        infoText: "inserire formato AAAA/AAAA",
        className: "col-md-6",
      },
      {
        id: "dataConseguimento",
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-6",
      },
    ],
    [
      {
        id: "votoTitolo010",
        field: "votoTitolo",
        label: "Voto",
        component: MInput,
        type: "text",
        className: "col-md-4",
      },
      {
        id: "baseVote010",
        field: "baseVote",
        label: "Base Voto",
        component: MInput,
        type: "text",
        className: "col-md-4",
      },
      {
        id: "lode",
        name: "lode",
        field: "lode",
        label: "Lode",
        component: MCheckbox,
        className: "col-md-4",
        infoText:
          "puoi selezionare la lode quando Voto e Base Voto sono uguali",
        onChange: () => this.onChangeLode(),
      },
    ],
    [
      {
        id: "riconoscimentoMIUR",
        field: "riconoscimentoMIUR",
        label: "Estremi Decreto riconoscimento",
        component: MInput,
        type: "text",
        className: "col-md-8",
      },
      {
        id: "numProtocollo",
        field: "numProtocollo",
        label: "Protocollo. n.",
        component: MInput,
        className: "col-md-4",
      },
    ],
    [
      {
        id: "equipollenzaTitolo010",
        field: "equipollenzaTitolo",
        label: "Riferimenti Ateneo Italiano",
        infoText: "Equipollenza titolo estero a titolo italiano",
        component: MLabel,
        className: "col-md-6 pt-3",
      },
    ],
    [
      {
        id: "searchUniversity010",
        component: MButton2,
        onClick: (e) => {
          this.searchUniversity(e);
        },
        label: "Cerca Ateneo",
        className: "col-md-12 mb-3",
        classElement: "btn btn-primary bg-dark",
      },
    ],
    [
      {
        id: "italianIstitution010",
        field: "istitution",
        label: "Presso Ateneo Italiano",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
      {
        id: "italianCity010",
        field: "city",
        label: "Città",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
    ],
    [
      {
        id: "description010",
        field: "description",
        label: "Titolo equipollente",
        payload: { options: this.PAYLOADS.qualificationTitle },
        component: MSelect,
        className: "col-md-12",
      },
    ],
  ];

  ERROR_MESSAGES = {
    istitution: "Dato obbligatorio",
    city: "",
    foreignIstitution: "Dato obbligatorio",
    foreignCity: "Dato obbligatorio",
    nation: "Dato obbligatorio",
    denominazione: "Dato obbligatorio",
    aa: "Dato obbligatorio",
    dataConseguimento: "Dato non valido",
    riconoscimentoMIUR: "Dato obbligatorio",
    baseVote: "Dato obbligatorio",
    votoTitolo: "Dato obbligatorio e numerico (min. 60, max. 110)",
    description: "Dato obbligatorio",
  };

  validation = {
    istitution: (value) => value !== "",
    city: (value) => value !== "",
    foreignIstitution: (value) => value !== "",
    foreignCity: (value) => value !== "",
    nation: (value) => value !== "",
    denominazione: (value) => value !== "",
    aa: (value) => this.validateAA(value),
    dataConseguimento: (value) => this.validateDataConseguimento(value),
    riconoscimentoMIUR: (value) => value !== "",
    votoTitolo: (value) => this.validateVoteBaseVote(value),
    baseVote: (value) => this.validateVoteBaseVote(value),
    description: (value) => value !== "",
    //lode: () => this.onChangeLode(),
  };

  normalize = (v) => {
    if (!v) return "";
    if (typeof v === "object" && v.value !== undefined) return v.value;
    return v;
  };

  //--- ---

  validateVoteBaseVote = (value) => {
    this.onChangeLode();

    if (value === "") {
      return false;
    }

    if (isNaN(value)) {
      return false;
    }

    if (value < 60 || value > 110) {
      return false;
    }

    return true;
  };

  validateAA = (value) => {
    //--- reset dataConseguimento ---
    this.setState({ dataConseguimento: "" });

    let aa = /^(\d{4})\/(\d{4})$/.test(value);

    if (!aa) {
      return false;
    } else {
      aa = value.split("/");

      const currentYear = new Date().getFullYear();
      if (parseInt(aa[1]) > currentYear) {
        return false;
      }

      if (parseInt(aa[1]) === parseInt(aa[0]) + 1) {
        return true;
      } else {
        return false;
      }
    }
  }; //validateAA

  validateDataConseguimento = (value) => {
    let regex = /^\d{4}-\d{2}-\d{2}$/;
    if (value === "" || !value.match(regex)) {
      return false;
    }

    //--- ---
    const today = new Date();
    const formDate = new Date(value);

    //in the future not valid
    if (formDate > today) {
      return false;
    }

    //--- ---
    if (Number.isNaN(formDate.getTime())) {
      return false;
    }
    const [year, month, day] = value.split("-").map(Number);

    if (month > 12 || day > 31) {
      return false;
    }

    const currentYear = new Date().getFullYear();
    if (year < currentYear - 90 || year > currentYear) {
      return false;
    }

    //--- guard on compliant AA --

    const aa = this.normalize(this.state.aa);

    if (aa) {
      const aaSplit = aa.split("/");
      const firstDate = new Date(`${parseInt(aaSplit[1])}-03-01`);
      const secondDate = new Date(`${parseInt(aaSplit[1]) + 1}-04-30`);

      if (formDate < firstDate || formDate > secondDate) {
        return false;
      }
    }

    return true;
  };

  onChangeLode = () => {
    const votoTitolo = this.normalize(this.state.votoTitolo);
    const baseVote = this.normalize(this.state.baseVote);

    if (
      isNaN(votoTitolo) ||
      isNaN(baseVote) ||
      votoTitolo === "" ||
      baseVote === "" ||
      parseInt(votoTitolo) !== parseInt(baseVote)
    ) {
      this.setState({ lode: { value: false, isValid: true } });
      return false;
    }

    return true;
  };

  componentDidMount() {
    const { defaultPayload } = this.props;

    if (defaultPayload) {
      const university = {
        city: defaultPayload.city,
        istitution: defaultPayload.istitution,
        uniCode: defaultPayload.uniCode,
      };

      this.setState({
        defaultValues: { ...this.emptyFields, ...defaultPayload },
        ...defaultPayload,
        showSearchUniversity: false,
        university,
      });
    }
  }

  searchUniversity = () => {
    this.setState({ showSearchUniversity: !this.state.showSearchUniversity });
  };

  onChangeUniversity = (university) => {
    this.onChange("city", university.city);
    this.onChange("istitution", university.istitution);
    this.setState({
      showSearchUniversity: false,
      university: university,
    });
  };

  getFormLabel = () => {
    return "Titolo estero";
  };

  getPayload = () => {
    this.payload = payloadBuilder(this.state);
    this.payload.qualificationType = "title11Estero";
    this.payload.extCode = "TITNONABILIT__EST";
    this.payload.qualificationCode = "title11";
    this.payload.classeConcorso = this.props.competitionClass;
    this.payload.template = "TITNONABILIT__EST";
    this.payload.uniCode = this.state.university.uniCode;

    return this.payload;
  };

  //--- ---

  render() {
    const { defaultValues, showSearchUniversity } = this.state;
    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);

    return (
      <>
        {showSearchUniversity && (
          <>
            <MSearchUniversity
              onChange={this.onChangeUniversity}
              searchUniversity={this.searchUniversity}
            />
          </>
        )}

        {!showSearchUniversity && <form className="user mt-4">{code}</form>}
      </>
    );
  }
}
